import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { SiTiktok } from "react-icons/si";

const Footer = () => {
  return (
    <footer className="bg-orange-50 border-t border-orange-100 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-orange-800">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-amber-500">
                Quick Runner
              </span>
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed">
              Your trusted destination for premium fashion and lifestyle products.
            </p>
            <div className="flex space-x-3 pt-2">
              <a
                href="https://vm.tiktok.com/ZMH3wnHCfU7VU-dkPeN/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white hover:bg-orange-100 rounded-lg text-orange-600 hover:text-pink-500 transition-all duration-200 shadow-sm"
                aria-label="Follow us on TikTok"
              >
                <SiTiktok className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold text-orange-700 uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/about", text: "About Us" },
                { to: "/faq", text: "FAQ" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={() => link.scrollToTop && window.scrollTo(0, 0)}
                    className="text-gray-500 hover:text-amber-600 transition-colors text-sm flex items-center group"
                  >
                    <span className="w-1.5 h-1.5 bg-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-all duration-200"></span>
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold text-orange-700 uppercase tracking-wider">
              Customer Service
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/contact", text: "Contact Us" },
                { to: "/privacy-policy", text: "Privacy Policy" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={() => link.scrollToTop && window.scrollTo(0, 0)}
                    className="text-gray-500 hover:text-amber-600 transition-colors text-sm flex items-center group"
                  >
                    <span className="w-1.5 h-1.5 bg-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-all duration-200"></span>
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold text-orange-700 uppercase tracking-wider">
              Contact Us
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <span className="text-orange-600 text-sm">
                  quickrunner56@gmail.com
                </span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <span className="text-orange-600 text-sm">
                  Durban, South Africa
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-orange-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} Quick Runner. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/privacy-policy"
                className="text-orange-600 hover:text-orange-800 transition-colors text-sm font-medium"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-orange-600 hover:text-orange-800 transition-colors text-sm font-medium"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
